import { AccountFrame, AccountStatus } from "@softmax/product-ux/account";
import { buildHref } from "@softmax/web-addresses";
import { NavigationFailure } from "@softmax/web-features/navigation/markers";
import { useRouter } from "@tanstack/react-router";

export function AccountError({ error }: { error: unknown }) {
  const router = useRouter();
  return (
    <AccountFrame
      title="Account"
      description="Manage your profile and access."
      section="settings"
      settingsHref={buildHref({ name: "account" })}
    >
      <NavigationFailure />
      <AccountStatus
        state={{
          status: "error",
          message:
            error instanceof Error
              ? error.message
              : "Account could not be loaded.",
        }}
        onRetry={() => void router.invalidate()}
      />
    </AccountFrame>
  );
}
